import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Flex,
  Heading,
  HStack,
  Image,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import talesParkImg from "../../../assets/talespark.jpg";

export default function TalesPark() {
  return (
    <Card>
      <CardHeader>
        <Center>
          <VStack>
            <Heading size="md">Tales Park</Heading>
            <Heading size="base">Domenica 10 maggio 2026, dalle ore 10</Heading>
            <Heading size="base">
              <Link href={"https://maps.app.goo.gl/5BmRDk3nWbBdfT3K9"}>
                Parco di Villa Correr (Casale di Scodosia, PD)
              </Link>
            </Heading>
          </VStack>
        </Center>
      </CardHeader>
      <CardBody>
        <SimpleGrid
          columns={2}
          minChildWidth="300px"
          rowGap="20px"
          columnGap="20px"
        >
          <Center>
            <VStack>
              <Link
                href={
                  "https://www.instagram.com/p/DUV_aqxjb_T/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                }
              >
                <Image src={talesParkImg} maxW="300px" />
              </Link>
              <Text>Villa Correr, 35040, Casale di Scodosia (PD)</Text>
              <Box
                as="iframe"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2812.343893368395!2d11.479060876004851!3d45.18013445234766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477f1acf299dcec9%3A0xa6771bd32ceae52c!2sVilla%20Correr!5e0!3m2!1sit!2sit!4v1777881213422!5m2!1sit!2sit"
                width="100%"
                height="300px"
                border="0"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </VStack>
          </Center>
          <Box>
            <Text as={"span"} fontWeight="bold">
              INGRESSO GRATUITO!
            </Text>
            <br />
            <br />
            <Text>
              Domenica 10 maggio preparatevi ad immergervi in un mondo fantasy,
              ricco di talento e avventure! I nostri espositori vi aspettano
              dalle ore 10 con le loro fantastiche e straordinarie opere. Non
              perdete quest’occasione per conoscerli tutti!
            </Text>
            <br /> <br />
            <Text>
              Ecco a voi i nostri espositori: <br />
              <Link href={"https://www.instagram.com/tecla.anita.autrice/"}>
                @tecla.anita.autrice
              </Link>
              <br />
              <Link href={"https://www.instagram.com/momenti_di_ge/"}>
                @momenti_di_ge
              </Link>
              <br />
              <Link href={"https://www.instagram.com/mirella.jewelry/"}>
                @mirella.jewelry
              </Link>
              <br />
              <Link href={"https://www.instagram.com/arcanadomine/"}>
                @arcanadomine
              </Link>
              <br />
              <Link href={"https://www.instagram.com/rhymil_una_nuova_era/"}>
                @rhymil_una_nuova_era
              </Link>
              <br />
              <Link href={"https://www.instagram.com/apium_sagittarii/"}>
                @apium_sagittarii
              </Link>
              <br />
              <Link href={"https://www.instagram.com/sartoria.maristella/"}>
                @sartoria.maristella
              </Link>
              <br />
              <Link href={"https://www.instagram.com/i_forgiatori_di_sogni/"}>
                @i_forgiatori_di_sogni
              </Link>
              <br />
              <Link href={"https://www.instagram.com/_thewitchofversailles_/"}>
                @_thewitchofversailles_
              </Link>
              <br />
              <Link href={"https://www.instagram.com/thesapphia_/"}>
                @thesapphia_
              </Link>
              <br />
              <Link href={"https://www.instagram.com/yume_teamofficial/"}>
                @yume_teamofficial
              </Link>
              <br />
              <Link
                href={"https://www.instagram.com/criticalrole_italycosplayers/"}
              >
                @criticalrole_italycosplayers
              </Link>
              <br />
              <Link href={"https://www.instagram.com/arietidiventura/"}>
                @arietidiventura
              </Link>
              <br />
              <Link href={"@iprintmonsters"}>@iprintmonsters</Link> <br />
              <Link href={"https://www.instagram.com/tales_comicsandgames/"}>
                @tales_comicsandgames
              </Link>
              <br />
            </Text>
            <br />
            <Text>Per info: info@talescomicsandgames.it</Text>
            <br />
            <br />
          </Box>
        </SimpleGrid>
      </CardBody>
    </Card>
  );
}
